var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ScrollPane",
    { staticClass: "component-render-details" },
    [
      !_vm.entry
        ? _c("div", { staticClass: "vue-ui-empty" }, [
            _vm._v("\n    No component selected\n  ")
          ])
        : [
            _c("ActionHeader", { attrs: { slot: "header" }, slot: "header" }, [
              _c("span", { staticClass: "title" }, [
                _c("span", { staticClass: "title-bracket" }, [_vm._v("<")]),
                _c("span", [_vm._v(_vm._s(_vm.componentName))]),
                _c("span", { staticClass: "title-bracket" }, [_vm._v(">")])
              ])
            ]),
            _c(
              "div",
              {
                staticClass: "metrics",
                class: {
                  "high-density": _vm.highDensity
                },
                attrs: { slot: "scroll" },
                slot: "scroll"
              },
              [
                _c(
                  "div",
                  { staticClass: "header" },
                  _vm._l(_vm.columns, function(column) {
                    return _c("div", { key: column, staticClass: "column" }, [
                      _vm._v("\n          " + _vm._s(column) + "\n        ")
                    ])
                  }),
                  0
                ),
                _vm._l(_vm.entries, function(e) {
                  return _c(
                    "div",
                    { key: e.id, staticClass: "metric selectable-item" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "type",
                          class: {
                            dim: e.count === 0
                          }
                        },
                        [_vm._v("\n          " + _vm._s(e.id) + "\n        ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "count",
                          class: {
                            dim: e.count === 0
                          }
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(e.count) + "\n        "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "total-time",
                          class: {
                            dim: e.totalTime === 0
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(Math.round(e.totalTime)) +
                              " ms\n        "
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "average-time",
                          class: {
                            dim: e.totalTime === 0
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                Math.round(e.totalTime / Math.max(e.count, 1))
                              ) +
                              " ms\n        "
                          )
                        ]
                      )
                    ]
                  )
                })
              ],
              2
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }